<template>
  <div class="atividades-informativos ml-4 mr-4">
    <LoadingModal v-if="isLoading" />
    <b-form>
      <b-row>
        <!-- -->
        <b-col cols="4">
          <label for="select-empresa">Empresa</label>
          <multiselect
            id="selecao-empresa-sol"
            v-model="value_empresa"
            required
            :options="empresas"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            @close="loadFiliais()"
            :preserve-search="true"
            placeholder="Selecione a empresa"
            label="empresa"
            track-by="empresa"
            name="empresa"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Empresa selecionada</span
              ></template
            >
          </multiselect>
        </b-col>

        <b-col cols="3">
          <label for="select-garagem_sol">Filial</label>
          <multiselect
            id="selecao-filial-sol"
            v-model="value_filial"
            required
            :options="filiais"
            :multiple="true"
            :taggable="true"
            :close-on-select="false"
            :clear-on-select="false"
            @close="loadinformativos()"
            :preserve-search="true"
            placeholder="Selecione a filial"
            label="filial"
            track-by="filial"
            name="filial"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Filial selecionada</span
              ></template
            >
          </multiselect>
        </b-col>

        <b-col cols="4" class="mb-0">
          <label for="input-busca">Pesquisa no grid </label>
          <b-form-input
            id="buscamonitoramento"
            v-model="search"
            required="required"
            placeholder="Nº do informativo ou assunto"
          ></b-form-input>
        </b-col>

        <!-- condicional para exibir o botão planilha-->
        <b-col cols="2" v-if="user.id_grupo == 13">
          <br />
          <b-button
            variant="primary"
            class="mr-2 mt-2"
            :disabled="carregando"
            @click="(carregando = true), loadPedidoFerias()"
          >
            <b-spinner v-if="carregando" small style="margin-bottom: 3px">
            </b-spinner>
            Planilha de férias
          </b-button>
        </b-col>

        <b-col cols="1">
          <!--                <b-col cols="1" v-if="user.id_grupo==18">   -->

          <br />
          <b-button
            variant="success"
            class="mr-2 mt-2"
            @click="
              loadNovoNroInformativo(), loadTipo(), loadDestino(), loadFormato()
            "
            v-b-modal.modal-multi-1
          >
            Novo informativo
          </b-button>
        </b-col>
      </b-row>
    </b-form>

    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
    </div>
    <!--tbl de dados -->
    <b-table
      id="saclancamentos"
      small
      hover
      striped
      sticky-header="756px"
      :items="itemsFiltered"
      :fields="fields"
    >
      <template #cell(conteudo)="data">
        {{
          data.item.conteudo
            ? data.item.conteudo.substring(0, 100) +
              (data.item.conteudo.length > 100 ? "..." : "")
            : ""
        }}
      </template>
      <template slot="cell(actions)" slot-scope="data">
        <b-button
          @click="editInformativo(data.item)"
          title="Acessar informativo"
          size="sm"
          variant="primary"
          class="mr-2 mt-2"
          v-b-modal.modal-multi-1
        >
          <i class="fa fa-exclamation-circle"></i>
        </b-button>
      </template>
    </b-table>

    <!--  MODAL SOLICITÇÕES  -->
    <div>
      <b-modal
        id="modal-multi-1"
        centered
        hide-footer
        size="xl"
        @close="nroInformativo = null"
        :title="modalTitulo"
        no-close-on-esc
        no-close-on-backdrop
      >
        <div>
          <b-row>
            <b-col sm="4" class="mt-1">
              <label for="input-parecer">Tipo de informativo</label>
              <div>
                <b-form-select
                  id="infoTipo"
                  v-model="informativo.tipo_id"
                  :options="tipos"
                  class="mb-3"
                  text-field="tipo"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col sm="4" class="mt-1">
              <label for="input-parecer">Formato do arquivo</label>
              <div>
                <b-form-select
                  id="infoFormato"
                  v-model="informativo.formato_id"
                  :options="formatos"
                  class="mb-3"
                  text-field="formato"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col sm="4" class="mt-1">
              <label for="input-parecer">Destino</label> --
              {{ informativo.destino_id }}
              <div>
                <b-form-select
                  v-model="informativo.destino_id"
                  :options="destinos"
                  text-field="destino"
                  @change="handleChange(informativo.destino_id)"
                />
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="6" class="mt-1">
              <label for="input-live">Assunto</label>
              <b-form-input
                id="infoAssunto"
                v-model="informativo.assunto"
                placeholder=""
                class="mb-3"
              ></b-form-input>
            </b-col>

            <b-col cols="2">
              <label for="input-admissao">Inicio da vigência</label>
              <b-form-datepicker
                id="datepicker-placeholder-ini"
                v-model="informativo.vigencia_ini"
                required
                placeholder="inicío"
                locale="pt-BR"
                date-format-options="DD/MM/YYYY"
              ></b-form-datepicker>
            </b-col>

            <b-col cols="2">
              <label for="input-admissao">Fim da vigência</label>
              <b-form-datepicker
                id="datepicker-placeholder-fim"
                v-model="informativo.vigencia_fim"
                required
                placeholder="Fim"
                locale="pt-BR"
                date-format-options="DD/MM/YYYY"
              ></b-form-datepicker>
            </b-col>

            <b-col cols="2">
              <b-form-checkbox
                id="lavador"
                class="mb-3 mt-5"
                v-model="informativo.cancelado"
                name="checkbox-1"
                value="true"
                unchecked-value="false"
                checked="true"
              >
                Cancelado
              </b-form-checkbox>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" class="mt-1">
              <label for="input-live">Link do documento</label>
              <b-form-input
                id="infoAssunto"
                v-model="informativo.link_arquivo"
                placeholder=""
                class="mb-3"
              ></b-form-input>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="8">
              <label for="textarea-small">Conteudo</label>
            </b-col>
            <b-col cols="6">
              <b-form-textarea
                id="infoConteudo"
                v-model="informativo.conteudo"
                size="sm"
                rows="22"
                placeholder="Digite a mensagem para o colaborador"
              ></b-form-textarea>
            </b-col>

            <b-col cols="3">
              <div class="pdf-container">
                <iframe
                  :src="pdfUrl ? pdfUrl : informativo.informativo_url"
                  width="100%"
                  height="500"
                ></iframe>
              </div>
            </b-col>

            <!-- selecionar tipo de associação -->
            <b-col cols="3">
              <div class="pdf-container">
                <div>
                  <b-row>
                    <div class="ml-4 mt-2 mb-2 p-2">
                      <!-- -- {{selected.map(fc => fc.id_funcao)}} -->
                      <b-button size="sm" @click="selectAllRows"
                        >Marcar todos</b-button
                      >
                    </div>

                    <div class="mt-2 mb-2 p-2">
                      <b-button size="sm" @click="clearSelected"
                        >Limpar todos</b-button
                      >
                    </div>
                  </b-row>

                  <b-row>
                    <b-col cols="12" class="mb-0">
                      <b-form-input
                        id="buscamonitoramento"
                        v-model="searchfunc"
                        v-if="informativo.destino_id == 5"
                        required="required"
                        placeholder="Faça seu filtro por registro"
                      ></b-form-input>
                    </b-col>
                    <b-col cols="12" class="mb-0">
                      <b-form-input
                        id="buscamonitoramento"
                        v-model="searchfc"
                        v-if="informativo.destino_id == 6"
                        required="required"
                        placeholder="Faça seu filtro por função"
                      ></b-form-input>
                    </b-col>
                  </b-row>
                  <!-- grid por EMPRESA -->
                  <!-- grid por EMPRESA -->
                  <!-- grid por EMPRESA -->
                  <b-table
                    v-if="informativo.destino_id == 1"
                    small
                    hover
                    striped
                    sticky-header="399px"
                    :items="itemsFilteredEmpresas"
                    :fields="fieldsFilteredEmpresas"
                    :select-mode="selectMode"
                    responsive="sm"
                    ref="selectableTable"
                    selectable
                    @row-selected="onRowSelected"
                  >
                    <!-- Example scoped slot for select state illustrative purposes -->
                    <template #cell(selected)="{ rowSelected }">
                      <template v-if="rowSelected">
                        <span aria-hidden="true">&check;</span>
                        <span class="sr-only">Selected</span>
                      </template>
                      <template v-else>
                        <span aria-hidden="true">&nbsp;</span>
                        <span class="sr-only">Not selected</span>
                      </template>
                    </template>
                  </b-table>

                  <!-- grid por FILIAL -->
                  <!-- grid por FILIAL -->
                  <!-- grid por FILIAL -->
                  <b-table
                    v-if="informativo.destino_id == 2"
                    small
                    hover
                    striped
                    sticky-header="399px"
                    :items="itemsFilteredFiliais"
                    :fields="fieldsFilteredFiliais"
                    :select-mode="selectMode"
                    responsive="sm"
                    ref="selectableTable"
                    selectable
                    @row-selected="onRowSelected"
                  >
                    <!-- Example scoped slot for select state illustrative purposes -->
                    <template #cell(selected)="{ rowSelected }">
                      <template v-if="rowSelected">
                        <span aria-hidden="true">&check;</span>
                        <span class="sr-only">Selected</span>
                      </template>
                      <template v-else>
                        <span aria-hidden="true">&nbsp;</span>
                        <span class="sr-only">Not selected</span>
                      </template>
                    </template>
                  </b-table>

                  <!-- grid por funcionario -->
                  <!-- grid por funcionario -->
                  <!-- grid por funcionario -->
                  <b-table
                    v-if="informativo.destino_id == 5"
                    small
                    hover
                    striped
                    sticky-header="355px"
                    :items="itemsFilteredFuncionarios"
                    :fields="fieldsFilteredFuncionarios"
                    :select-mode="selectMode"
                    responsive="sm"
                    ref="selectableTable"
                    selectable
                    @row-selected="onRowSelected"
                  >
                    <!-- Example scoped slot for select state illustrative purposes -->
                    <template #cell(selected)="{ rowSelected }">
                      <template v-if="rowSelected">
                        <span aria-hidden="true">&check;</span>
                        <span class="sr-only">Selected</span>
                      </template>
                      <template v-else>
                        <span aria-hidden="true">&nbsp;</span>
                        <span class="sr-only">Not selected</span>
                      </template>
                    </template>
                  </b-table>
                  <b-pagination
                    size="sm"
                    v-if="informativo.destino_id == 5"
                    v-model="page"
                    :total-rows="count"
                    :per-page="limitfunc"
                  ></b-pagination>

                  <!-- grid por funcão -->
                  <!-- grid por funcão -->
                  <!-- grid por funcão -->
                  <b-table
                    v-if="informativo.destino_id == 6"
                    small
                    hover
                    striped
                    sticky-header="399px"
                    :items="itemsFilteredFuncoes"
                    :fields="fieldsFilteredFuncoes"
                    :select-mode="selectMode"
                    responsive="sm"
                    ref="selectableTable"
                    selectable
                    @row-selected="onRowSelected"
                  >
                    <!-- Example scoped slot for select state illustrative purposes -->
                    <template #cell(selected)="{ rowSelected }">
                      <template v-if="rowSelected">
                        <span aria-hidden="true">&check;</span>
                        <span class="sr-only">Selected</span>
                      </template>
                      <template v-else>
                        <span aria-hidden="true">&nbsp;</span>
                        <span class="sr-only">Not selected</span>
                      </template>
                    </template>
                  </b-table>
                </div>
              </div>
            </b-col>
          </b-row>

          <b-row>
            <!-- inserir o arquivo -->

            <b-col cols="12">
              <b-form-file
                v-model="file"
                @input="uploadPhoto()"
                placeholder="Selecione o arquivo"
                ref="file-input"
                class="mb-2"
              ></b-form-file>
            </b-col>

            <b-button
              v-if="informativo && informativo.dt_cadastro"
              class="mt-3"
              variant="success"
              block
              @click="postInformativo()"
              >Atualizar informativo</b-button
            >

            <!--
                  <b-col cols="2">
                    <b-button @click="file = null">Limpar arquivo</b-button>                
                  </b-col>

                  <b-col cols="3" v-if="user.id_grupo==18">                
                    <b-button  variant="warning" @click="openModal">
                      Visualizar arquivo selecionado
                    </b-button>                      
                  </b-col>
    -->
          </b-row>

          <b-row>
            <b-col cols="12">
              <p class="mt-2">
                Arquivo selecionado: <b>{{ file ? file.name : "" }}</b>
              </p></b-col
            >
            <!-- <p v-if="this.user.id_grupo == 18" class="ml-3">{{ informativo.informativo_url}}</p> -->
          </b-row>

          <!-- </form> -->
          <b-button
            class="mt-3"
            variant="success"
            block
            v-if="!informativo.informativo_url"
            @click="postInformativo(), loadinformativos()"
            >Gravar</b-button
          >
        </div>
      </b-modal>
    </div>

    <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->

    <!-- abrir pdf -->
    <!-- abrir pdf -->
    <!-- abrir pdf -->

    <b-modal id="modal-1" centered title="Visualizador de PDF">
      <div class="pdf-container">
        <iframe :src="pdfUrl" width="100%" height="500"></iframe>
      </div>
    </b-modal>

    <!-- abrir pdf -->
    <!-- abrir pdf -->
    <!-- abrir pdf -->
  </div>
</template>


<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import Multiselect from "vue-multiselect";
import moment, { now } from "moment";
import { mapState } from "vuex";
import { pdf } from "vue-pdf";
import LoadingModal from "../utilitarios/LoadingModal";

export default {
  name: "InfoCadastro",

  props: {
    pdfUrl: String,
  },

  computed: {
    ...mapState(["user"]),

    itemsFiltered() {
      return this.informativos.filter((item) => {
        return (
          (item.informativo_id ?? "").toString().indexOf(this.search) > -1 ||
          (item.id ?? "").toString().indexOf(this.search) > -1 ||
          (item.tipo_destino ?? "").toString().indexOf(this.search) > -1 ||
          (item.assunto ?? "").toString().indexOf(this.search) > -1
        );
      });
    },

    itemsFilteredEmpresas() {
      let valorefu = [];
      valorefu = this.empresas.filter((item) => {
        return item.empresa.indexOf(this.searchfunc) > -1;
      });
      return valorefu;
    },

    itemsFilteredFiliais() {
      let valorefu = [];
      valorefu = this.filiais.filter((item) => {
        return item.filial.indexOf(this.searchfunc) > -1;
      });
      return valorefu;
    },

    itemsFilteredArea() {
      let valorefu = [];
      valorefu = this.funcionarios.filter((item) => {
        return item.registro.indexOf(this.searchfunc) > -1;
      });
      return valorefu;
    },

    itemsFilteredDepto() {
      let valorefu = [];
      valorefu = this.funcionarios.filter((item) => {
        return item.registro.indexOf(this.searchfunc) > -1;
      });
      return valorefu;
    },

    itemsFilteredFuncionarios() {
      let valorefu = [];
      valorefu = this.funcionarios.filter((item) => {
        return item.registro.indexOf(this.searchfunc) > -1;
      });
      return valorefu;
    },

    itemsFilteredFuncoes() {
      return this.funcoes.filter((item) => {
        return (
          (item.funcao ?? "")
            .toString()
            .toLowerCase()
            .indexOf(this.searchfc.toLowerCase()) > -1
        );
      });
    },

    modalTitulo() {
      const numero = this.nroInformativo ?? this.informativo?.informativo_id;
      return `Cadastro de informativo Nº.: ${numero}`;
    },
  },

  data: function () {
    return {
      isLoading: false,
      empresas: [],
      empresa: {},
      filiais: [],
      filial: {},
      areas: [],
      deptos: [],
      funcionarios: [],
      funcoes: [],

      informativos: [],
      informativo: {},
      formatos: [],
      destinos: [],
      nroInformativo: null,
      file: null,
      tipos: [],

      limitfunc: 0,
      count: 0,
      page: 1,
      selectMode: "multi",
      selected: [],

      mode: "save",
      carregando: false,
      atualizando: false,
      value_empresa: [], // [this.empresas],
      value_filial: [],
      value_status: [],
      //value_filial:[],// [] lista

      status: {},
      statuss: [], // [] lista

      permissoes: [],
      permissao: {},

      search: "",
      searchfunc: "",
      searchfc: "",

      value_id_area: "",
      barra_inicial: 0,
      barra_limite: 60000 * 5, // temporizador 60.000 milisegundos refere-se a 1 minutos

      fields: [
        //        { key: "informativo_id", label: "Nº Informativo", sortable: true },
        {
          key: "informativo_id",
          label: "Nº Informativo",
          sortable: true,
          formatter: (value, key, item) => {
            return value !== null && value !== undefined ? value : item.id;
          },
        },

        { key: "empresa_id", label: "Empresa", sortable: true },
        { key: "filial_id", label: "Filial", sortable: true },
        //{ key: "formato", label: "FORMATO", sortable: true },
        //{ key: "tipo", label: "TIPO", sortable: true },
        { key: "tipo_destino", label: "DESTINO", sortable: true },
        { key: "assunto", label: "ASSUNTO", sortable: true },
        { key: "conteudo", label: "Conteudo", sortable: true },
        {
          key: "vigencia_ini",
          label: "Vigência inicio",
          sortable: true,
          formatter: (value, key, informativos) => {
            return moment(informativos.vigencia_ini)
              .format("DD/MM/YYYY")
              .replace("Data inválida", "-");
          },
        },
        {
          key: "vigencia_fim",
          label: "Vigência fim",
          sortable: true,
          formatter: (value, key, informativos) => {
            return moment(informativos.vigencia_fim)
              .format("DD/MM/YYYY")
              .replace("Data inválida", "-");
          },
        },
        {
          key: "cancelado",
          label: "Cancelado",
          sortable: true,
          formatter: (value) => (value ? "Sim" : "Não"),
        },
        {
          key: "dt_cadastro",
          label: "Data cadastro",
          sortable: true,
          formatter: (value, key, informativos) => {
            return moment(informativos.dt_cadastro)
              .format("DD/MM/YYYY - HH:mm ")
              .replace("Data inválida", "-");
          },
        },
        {
          key: "dt_alteracao",
          label: "Data alteração",
          sortable: true,
          formatter: (value, key, informativos) => {
            return moment(informativos.dt_alteracao)
              .format("DD/MM/YYYY - HH:mm")
              .replace("Data inválida", "-");
          },
        },

        { key: "actions", label: "Atualizar" },
      ],

      //////// seleção de empresas
      fieldsFilteredEmpresas: [
        { key: "selected", label: "Seleção", sortable: true },
        { key: "id_empresa", label: "Id", sortable: true },
        { key: "empresa", label: "Empresa", sortable: true },
        //{ key: 'actions', label: 'Ações' },
      ],

      //////// seleção de filiais
      fieldsFilteredFiliais: [
        { key: "selected", label: "Seleção", sortable: true },
        { key: "id_filial_erp", label: "Id", sortable: true },
        { key: "filial", label: "Filial", sortable: true },
        //{ key: 'actions', label: 'Ações' },
      ],

      //////// seleção de funcionarios
      fieldsFilteredFuncionarios: [
        { key: "selected", label: "Seleção", sortable: true },
        { key: "registro", label: "Registro", sortable: true },
        { key: "funcao", label: "Função", sortable: true },
        //{ key: 'actions', label: 'Ações' },
      ],

      //////// seleção de funcionarios
      fieldsFilteredFuncoes: [
        { key: "selected", label: "Seleção", sortable: true },
        { key: "id_funcao_erp", label: "Id", sortable: true },
        { key: "funcao", label: "Função", sortable: true },
        //{ key: 'actions', label: 'Ações' },
      ],
    };
  },

  components: {
    Multiselect,
    LoadingModal,
  },

  methods: {
    handleChange(campo) {
      switch (campo) {
        case 1: // empresa
          this.loadEmpresas();
          break;
        case 2: // filial
          this.loadFiliais();
          break;
        case 3: // area
          // this.loadFuncoes();
          break;
        case 4: //depto
        //this.loadFuncionarios();
        case 5: // funcionarios
          this.loadFuncionarios();
          break;
        case 6: // funcoes
          this.loadFuncoes();
          break;
        // ... e assim por diante
      }
    },

    loadEmpresas() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        psg: `${this.user.psg}`,
      };

      const url = `${baseApiUrl}/ctr/empresa`;
      axios.get(url, { params }).then((res) => {
        this.empresas = res.data.map((empresa) => {
          return {
            id_empresa: empresa.id_empresa,
            empresa: empresa.nomeempresarial,
          };
        });
      });
    },

    loadFiliais() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        id_empresa: `${this.user.id_empresa}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/ctr/empresa/filial`;
      axios.get(url, { params }).then((res) => {
        this.filiais = res.data.map((filial) => {
          return { id_filial_erp: filial.id_filial_erp, filial: filial.filial };
        });
      });
    },

    clearFiles() {
      this.$refs["file-input"].reset();
    },

    //enviar documentos
    async uploadPhoto() {
      if (!this.file) return;

      const formData = new FormData();
      formData.append("imagem", this.file);

      try {
        const url = `${baseApiUrl}/utils/informativo`;
        const response = await axios.post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        this.pdfUrl = response.data;
        console.log("Arquivo enviado com sucesso!", response.data);
      } catch (error) {
        console.error("Erro ao enviar a foto:", error);
      }
    },

    openModal() {
      // Defina a URL do PDF antes de abrir o modal
      this.pdfUrl;
      this.$bvModal.show("modal-1");
    },
    clearPdfUrl() {
      // Limpa a URL do PDF quando o modal é fechado
      this.pdfUrl = "";
    },

    loadTipo() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/informativo/tipo`;
      axios.get(url, { params }).then((res) => {
        this.tipos = res.data.map((tip) => {
          return { ...tip, value: tip.id, tipo: tip.tipo };
        });
      });
    },

    loadFormato() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/informativo/formato`;
      axios.get(url, { params }).then((res) => {
        this.formatos = res.data.map((form) => {
          return { ...form, value: form.id, formato: form.formato };
        });
      });
    },

    loadDestino() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/informativo/destino`;
      axios.get(url, { params }).then((res) => {
        this.destinos = res.data.map((des) => {
          return { ...des, value: des.id, destino: des.destino };
        });
      });
    },

    async loadNovoNroInformativo() {
      try {
        const params = {
          id_grupo_empresa: this.user.id_grupo_empresa,
          psg: this.user.psg,
        };

        const url = `${baseApiUrl}/informativo/nro`;
        const response = await axios.get(url, { params });

        // Verifica se os dados vieram como esperado
        if (response.data?.rows?.[0]?.nextval) {
          this.nroInformativo = response.data.rows[0].nextval;
          console.warn("Resposta inesperada:", response.data);
        } else {
          console.warn("Resposta inesperada:", response.data);
          this.nroInformativo = null;
        }
      } catch (error) {
        console.error("Erro ao carregar número do informativo:", error);
        this.nroInformativo = null;
      }
    },

    async postInformativo() {
      // Adicione 'async' aqui
      this.isLoading = true; // Desative o indicador de carregamento
      let corpo = {
        id: this.nroInformativo
          ? this.nroInformativo
          : `${this.informativo.informativo_id}`,
        id_funcao_erp: `${[this.selected.map((fc) => fc.id_funcao_erp)]}`,
        funcionario_cadastro_id: `${this.user.id_funcionario}`,
        empresa_id: `${this.user.id_empresa}`,
        filial_id: `${this.user.id_filial_erp}`,
        dt_cadastro: `${this.informativo.dt_cadastro}`,
        formato_id: `${this.informativo.formato_id}`,
        tipo_id: `${this.informativo.tipo_id}`,
        destino_id: `${this.informativo.destino_id}`,
        assunto: `${this.informativo.assunto}`,
        conteudo: `${this.informativo.conteudo}`,
        informativo_url: this.pdfUrl
          ? `${this.pdfUrl}`
          : `${this.informativo.informativo_url}`,
        vigencia_ini: `${this.informativo.vigencia_ini}`,
        vigencia_fim: `${this.informativo.vigencia_fim}`,
        dt_cadastro: `${this.informativo.dt_cadastro}`,
        cancelado: `${this.informativo.cancelado}`,
        link_arquivo: `${this.informativo.link_arquivo}`,
        psg: this.user.psg,
      };

      const url = `${baseApiUrl}/informativo`;

      try {
        // Use try-catch para lidar com erros em async/await
        await axios.post(url, corpo); // Use 'await' para esperar a Promise resolver

        this.postInformativoDestinoFuncionario();
        this.loadinformativos();
      } catch (error) {
        // Capture o erro aqui
        showError(error);
      }
    },

    // ... (seu código anterior)

    postInformativoDestinoFuncionario() {
      let valorIdCalculado;

      switch (
        parseInt(this.informativo.destino_id) // Converte para número para o switch
      ) {
        case 1:
          valorIdCalculado = this.selected.map((fc) => parseInt(fc.id_empresa));
          break;
        // ... EMPRESA

        case 2:
          valorIdCalculado = this.selected.map((fc) =>
            parseInt(fc.id_filial_erp)
          );
          break;
        // ... FILIAL
        case 3:
          valorIdCalculado = this.selected.map((fc) => parseInt(fc.area_id));
          break;
        // ... AREA
        case 4:
          valorIdCalculado = this.selected.map((fc) => parseInt(fc.depto_id));
          break;
        // ... DEPTO
        case 5:
          valorIdCalculado = this.selected.map((fc) =>
            parseInt(fc.id_funcionario)
          );
          break;
        // ... FUNCIONARIO
        case 6:
          // Agora, this.selected.map(...) já retorna um array de números.
          // Certifique-se de que os IDs sejam números, não strings, se necessário.
          valorIdCalculado = this.selected.map((fc) =>
            parseInt(fc.id_funcao_erp)
          );
          break;
        default:
          valorIdCalculado = []; // Se não houver valor, envie um array vazio
          console.warn("Destino ID desconhecido:", this.informativo.destino_id);
          break;
      }

      let corpo = {
        psg: this.user.psg,
        empresa_id: `${this.user.id_empresa}`,
        funcionario_cad_id: `${this.user.id_funcionario}`,
        destino_id: `${this.informativo.destino_id}`,
        // Envia valor_id como um array de números
        valor_id: valorIdCalculado,
        informativo_id: this.nroInformativo
          ? this.nroInformativo
          : `${this.informativo.informativo_id}`,
      };

      const url = `${baseApiUrl}/informativo/destinofuncionarios`;
      axios
        .post(url, corpo)
        .then(() => {
          this.$toasted.global.defaultSuccess();
          this.isLoading = false; // Desative o indicador de carregamento
        })
        .catch(showError);
    },

    editInformativo(informativo) {
      this.informativo = { ...informativo };
    },

    loadFuncionarios() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        empresa_id: `${this.user.id_empresa}`,
        id_empresa: `${this.user.id_empresa}`,
        //"id_filial": `${this.filial.id_filial_erp}`,
        page: `${this.page}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/folha/funcionario/listagem`;
      axios.get(url, { params }).then((res) => {
        this.funcionarios = res.data.data;
        this.count = res.data.count;
        this.limitfunc = res.data.limitfunc;
      });
    },

    loadFuncoes() {
      let params = {
        //   "id_empresa": `${this.user.id_empresa}`,
        id_empresa: `${this.user.id_empresa}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/folha/funcionario/funcao`;
      axios
        .get(url, { params })
        .then((res) => {
          this.funcoes = res.data.map((func) => {
            return { ...func, value: func.id_funcao_erp, funcao: func.funcao }; //// para pegar o valor tem que usar o ... atribuicao value
          });
        })
        .catch(showError);
    },

    loadPermissao() {
      let params = {
        id_grupo: `${this.user.id_grupo}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };

      const url = `${baseApiUrl}/sac/permissao`;
      axios.get(url, { params }).then((res) => {
        this.permissoes = res.data.map((permissao) => {
          return { ...permissao, id_area: permissao.id_area };
        });
        this.loadinformativos();
      });
    },

    async loadinformativos() {
      this.isLoading = true;
      let params = {
        empresa_id: `${[this.user.id_empresa]}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
        // "id_filial": `${[this.value_filial.map(a => a.id_filial_erp)]}`,
        // "id_status": `${[this.value_status.map(r => r.id_status)]}`,
        // "id_area": `${[this.permissoes.map(p => p.id_area)]}`,
      };

      const url = `${baseApiUrl}/informativo/conteudo`; // Removi o 'await' daqui, pois 'url' não é uma Promise

      try {
        // Use 'await' para esperar a Promise resolver e atribua o resultado a 'res'
        const res = await axios.get(url, { params });
        this.informativos = res.data;
        this.isLoading = false;

        // console.log("dados dos informativos " + informativos);
      } catch (error) {
        showError(error);
        // this.isLoading = false; // Importante: Desativar isLoading mesmo em caso de erro
      }
    },

    reset() {
      this.informativo = {};
      this.nroInformativo = null;
      this.pdfUrl = "";
      this.funcionarios = [];
      this.clearFiles();
    },

    onRowSelected(items) {
      this.selected = items;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    selectThirdRow() {
      // Rows are indexed from 0, so the third row is index 2
      this.$refs.selectableTable.selectRow(2);
    },
    unselectThirdRow() {
      // Rows are indexed from 0, so the third row is index 2
      this.$refs.selectableTable.unselectRow(2);
    },
  },

  watch: {
    page() {
      this.loadFuncionarios();
    },
  },

  mounted() {
    this.loadEmpresas();
    this.loadTipo();
    this.loadFormato();
    this.loadDestino();
    this.loadinformativos();
    //this.loadFuncoes()
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: "Procurar arquivo";
}
</style>